export default __webpack_public_path__ + "static/media/messages-white.0bb2f90f.svg";